import { defineStore } from "pinia"

import axios from "@axios"
import {reportError} from "@/plugins/misc"

const baseUrl = '/tag/'

export const useTagsStore = defineStore('tagsStore', () => {
  const tag = ref({
    _id: '',
    tagName: '',
    tagDescription: '',
    tagShortDescription: '',
  })

  const tags = ref([])
  const availableTags = ref([])

  function initTags(data) {
    tags.value = data
  }

  function initTag(data) {
    tag.value = data
  }

  async function getTags() {
    try {
      let res = await axios.get(baseUrl, {
        params: {
        }
      })

      if (!res.data) {
        //@todo add some ui state changes here, like validators and such
        console.log("No data found")
      }

      initTags(res.data)
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:getTags", error.message, null,null,null, error)
    }
  }

  async function getAvailableTags() {
    try {
      let res = await axios.get(`${baseUrl}available`, {
        params: {
        }
      })

      if (!res.data) {
        console.log("No data found")
      }

      availableTags.value = res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:getAvailableTags", error.message, null,null,null, error)
    }
  }

  async function getTagById(id) {
    try {
      let res = await axios.get(`${baseUrl}${id}`, {
        params: {
        }
      })

      if (!res.data) {
        //@todo add some ui state changes here, like validators and such
        console.log("No data found")
      }
            
      initTag(res.data)
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:getTagById", error.message, null,null,null, error)
    }
  }

  async function createTag(data) {
    try {
      let res = await axios.post(baseUrl, data, {
        params: {
        }
      })
      
      return res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:createTag", error.message, null,null,null, error)
    }
  }

  async function updateTag(id, data) {
    try {
      let res = await axios.put(`${baseUrl}${id}`, data, {
        params: {
        }
      })
      
      return res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:updateTag", error.message, null,null,null, error)
    }
  }

  async function deleteTag(id) {
    try {
      let res = await axios.delete(`${baseUrl}${id}`, {
        params: {
        }
      })
      
      return res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:deleteTag", error.message, null,null,null, error)
    }
  }

  async function getActiveMembers(id) {
    try {
      let res = await axios.get(`${baseUrl}${id}/active-members`, {
        params: {
        }
      })
      
      return res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:getActiveMembers", error.message, null,null,null, error)
      
      return { count: 0, members: [] }
    }
  }

  async function getBulkMemberCounts() {
    try {
      let res = await axios.get(`${baseUrl}bulk/member-counts`, {
        params: {
        }
      })
      
      return res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:getBulkMemberCounts", error.message, null,null,null, error)
      
      return {}
    }
  }

  async function requestCustomTag(tagName) {
    try {
      let res = await axios.post(`${baseUrl}user-request`, { tagName }, {
        params: {
        }
      })

      return res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:requestCustomTag", error.message, null,null,null, error)

      return null
    }
  }

  async function getPartnerTagCounts() {
    try {
      let res = await axios.get(`${baseUrl}partners/counts`)
      
      return res.data
    } catch (error) {
      console.error(error)
      reportError("tags.store.js:getPartnerTagCounts", error.message, null,null,null, error)
      
      return {}
    }
  }

  return {
    tag,
    tags,
    availableTags,
    initTags,
    initTag,
    getTags,
    getAvailableTags,
    getTagById,
    createTag,
    updateTag,
    deleteTag,
    getActiveMembers,
    getBulkMemberCounts,
    getPartnerTagCounts,
    requestCustomTag
  }
})